export class TablePageChangeEvent {
  public constructor(
    public readonly page: number,
    public readonly first: number,
    public readonly rows: number,
    public readonly pageCount: number,
  ) {}
}
